import { render } from "./AssignaturaView.vue?vue&type=template&id=d6321192&scoped=true"
import script from "./AssignaturaView.vue?vue&type=script&lang=js"
export * from "./AssignaturaView.vue?vue&type=script&lang=js"

import "./AssignaturaView.vue?vue&type=style&index=0&id=d6321192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6321192"]])

export default __exports__